export const testimonials = [
  {
    id: 1,
    text: 'Bebeğimizin doğum anısı için hazırlattığımız çerçeve harika oldu! Her detay özenle hazırlanmış, kalitesi mükemmel. Teşekkürler Hediyatik!',
    author: 'Ayşe Yılmaz',
    verified: true,
    image: 'https://readdy.ai/api/search-image?query=Happy%20young%20Turkish%20mother%20holding%20beautiful%20wooden%20baby%20birth%20frame%20with%20pastel%20decorations%20smiling%20warmly%20natural%20lighting%20soft%20background%20satisfied%20customer%20testimonial%20photo&width=500&height=600&seq=test1&orientation=portrait'
  },
  {
    id: 2,
    text: 'Düğünümüz için özel tasarım yaptırdık. Hayal ettiğimizden çok daha güzel oldu. Misafirlerimiz çok beğendi, herkese tavsiye ediyorum!',
    author: 'Mehmet ve Zeynep Kaya',
    verified: true,
    image: 'https://readdy.ai/api/search-image?query=Happy%20Turkish%20couple%20holding%20elegant%20wedding%20memory%20frame%20smiling%20together%20natural%20lighting%20soft%20background%20satisfied%20customers%20testimonial%20photo&width=500&height=600&seq=test2&orientation=portrait'
  },
  {
    id: 3,
    text: 'Kızımın mezuniyeti için aldığımız tasarım çok özel oldu. Hızlı teslimat ve kaliteli işçilik. Kesinlikle tekrar sipariş vereceğim.',
    author: 'Fatma Demir',
    verified: true,
    image: 'https://readdy.ai/api/search-image?query=Proud%20Turkish%20mother%20with%20daughter%20holding%20graduation%20memory%20frame%20both%20smiling%20happily%20natural%20lighting%20soft%20background%20satisfied%20customer%20testimonial%20photo&width=500&height=600&seq=test3&orientation=portrait'
  }
];